import useDarkMode from '@/utils/hooks/utils/useDarkMode';

type YoutubeIconProps = React.ComponentPropsWithRef<'svg'> & {
    forceLightMode?: boolean;
    size?: number;
    color?: string;
};

export function YoutubeIcon({
    forceLightMode = false,
    size = 24,
    color,
    ...restProps
}: YoutubeIconProps) {
    const { isDarkMode } = useDarkMode();
    const darkMode = isDarkMode && !forceLightMode ? isDarkMode() : false;

    if (darkMode) {
        return (
            <svg
                data-testid="logo-youtube"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <path
                    d="M23.498 6.18601C23.3624 5.67529 23.095 5.20915 22.7226 4.83428C22.3502 4.4594 21.8858 4.18896 21.376 4.05001C19.505 3.54501 12 3.54501 12 3.54501C12 3.54501 4.495 3.54501 2.623 4.05001C2.11341 4.1892 1.64929 4.45975 1.27708 4.8346C0.904861 5.20944 0.637591 5.67545 0.502 6.18601C0 8.07001 0 12 0 12C0 12 0 15.93 0.502 17.814C0.637586 18.3247 0.904975 18.7909 1.27739 19.1658C1.64981 19.5406 2.11418 19.8111 2.624 19.95C4.495 20.455 12 20.455 12 20.455C12 20.455 19.505 20.455 21.377 19.95C21.8869 19.8112 22.3513 19.5407 22.7237 19.1659C23.0961 18.791 23.3635 18.3248 23.499 17.814C24 15.93 24 12 24 12C24 12 24 8.07001 23.498 6.18601ZM9.545 15.568V8.43201L15.818 12L9.545 15.568Z"
                    fill={color ?? 'white'}
                />
            </svg>
        );
    }

    return (
        <svg
            data-testid="logo-youtube"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <path
                d="M23.498 6.18601C23.3624 5.67529 23.095 5.20915 22.7226 4.83428C22.3502 4.4594 21.8858 4.18896 21.376 4.05001C19.505 3.54501 12 3.54501 12 3.54501C12 3.54501 4.495 3.54501 2.623 4.05001C2.11341 4.1892 1.64929 4.45975 1.27708 4.8346C0.904861 5.20944 0.637591 5.67545 0.502 6.18601C0 8.07001 0 12 0 12C0 12 0 15.93 0.502 17.814C0.637586 18.3247 0.904975 18.7909 1.27739 19.1658C1.64981 19.5406 2.11418 19.8111 2.624 19.95C4.495 20.455 12 20.455 12 20.455C12 20.455 19.505 20.455 21.377 19.95C21.8869 19.8112 22.3513 19.5407 22.7237 19.1659C23.0961 18.791 23.3635 18.3248 23.499 17.814C24 15.93 24 12 24 12C24 12 24 8.07001 23.498 6.18601ZM9.545 15.568V8.43201L15.818 12L9.545 15.568Z"
                fill={color ?? '#FF0000'}
            />
        </svg>
    );
}
